import { Component, Vue, Prop, Emit, Mixins } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';
import BASEAPI from '@/util/BASEAPI';


@Component({
})
export default class SALink extends Mixins(BASEComponentVue) {
    @Prop({
        type: String,
        default: "",
    })
    public title!: string;

    @Prop({
        type: String,
        default: "",
    })
    public link!: string;

    @Emit("click")
    public click() {
    }

    public onButtonClick() {
        this.$emit("click");
    }

}
